import { paceStatusIcon } from "enums/paceStatus";
import { AssessmentCentreUser, UserAssessments } from "services/assessmentCentre";
import { RequestInfo } from "store/slice/store.types";
import { Pagination } from "types/global";
import { generateID } from "utils/utils";

export type ConvertedAssessmentCentre = {
    data: ConvertedAssessmentCentreUserData[];
    meta: Pagination;
    status: RequestInfo;
};

export type AssessmentCentrePaceStatus = keyof typeof paceStatusIcon;

export type ConvertedAssessmentCentreUserData = {
    id: number;
    userName: string;
    email: string;
    linkedinId: string | null;
    lastContactedOn: string | null;
    paceStatus: AssessmentCentrePaceStatus;
    paceRetakeAvailable: boolean;
    assessments: UserAssessments[];
    teams: { id: number; name: string }[];
    checked: boolean;
    status: "idle" | "pending" | "error";
    personId: number | null;
    isPacePending: boolean;
};

export const convertUserAssessmentList = (data: AssessmentCentreUser[]): ConvertedAssessmentCentreUserData[] => {
    return data.map((userData) => {
        const lastContactedString = userData.last_contacted_datetime?.toString();
        const lastContacted =
            typeof lastContactedString === "string" && !lastContactedString?.includes("Z")
                ? `${lastContactedString}Z`
                : lastContactedString;

        let paceStatus: AssessmentCentrePaceStatus = "Not Sharing";

        if (userData.optin_share_data) {
            paceStatus = userData.pace_status as AssessmentCentrePaceStatus;
        }

        const paceStaleStatus = userData.pace_stale_status?.id;

        return {
            id: userData.id,
            userName: userData.name,
            email: userData.email,
            linkedinId: userData.person.linkedin_id,
            lastContactedOn: lastContacted ?? null,
            paceStatus: paceStatus,
            paceRetakeAvailable:
                paceStaleStatus === "STALE_3" || paceStaleStatus === "STALE_6" || paceStaleStatus === "OLD",
            assessments: userData.user_assessments,
            teams: userData.teams.map((team) => ({ ...team, id: generateID() })),
            checked: false,
            status: "idle",
            personId: userData.person.id,
            isPacePending: paceStatus === "Incomplete" || paceStatus === "Not started",
        };
    });
};
